



































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  DxChart,
  DxSeries,
  DxCommonSeriesSettings,
  DxArgumentAxis,
  DxValueAxis,
  DxTitle,
  DxLabel,
  DxTooltip,
  DxLegend,
} from "devextreme-vue/chart";
import DxPieChart, { DxSmallValuesGrouping } from "devextreme-vue/pie-chart";
import { DxDataGrid, DxColumn } from "devextreme-vue/data-grid";
import { DxDateBox } from "devextreme-vue/date-box";
import fichajes_empleadoModule from "@/store/modules/fichajes_empleado-module";
import fichajes_hoy from "./fichajes_hoy.vue";
import CalendarioLaboralEmpleados from "../Calendarios/CalendarioLaboralEmpleados.vue";

// Interfaces para tipado
interface DateRange {
  start: Date;
  end: Date;
}

interface Analytics {
  totalHours: number;
  avgHoursPerDay: number;
  workedDays: number;
  attendanceRate: number;
  lateArrivals: number;
  lateRate: number;
  overtimeHours: number;
  overtimeRate: number;
  productivityScore: number;
}

interface TimeRecord {
  id: number;
  date: Date;
  date_in: Date;
  date_out: Date;
  clockIn: string;
  clockOut: string;
  totalHours: number;
  Hours: number;
  status: "normal" | "late" | "early" | "overtime";
}

interface Insight {
  id: number;
  title: string;
  description: string;
}

interface DashboardPromedioHorasDiaDto {
  dia_numero_semana: number;
  dia_semana: string;
  horas_media: number;
}
interface ChartDataPoint {
  day?: string;
  week?: string;
  hours?: number;
  productivity?: number;
  status?: string;
  count?: number;
}

@Component({
  components: {
    DxChart,
    DxPieChart,
    DxSeries,
    DxCommonSeriesSettings,
    DxArgumentAxis,
    DxValueAxis,
    DxTitle,
    DxLabel,
    DxTooltip,
    DxLegend,
    DxSmallValuesGrouping,
    DxDataGrid,
    DxColumn,
    DxDateBox,
    fichajes_hoy,
    CalendarioLaboralEmpleados,
  },
})
export default class DashboardFichajes extends Vue {
  // Datos reactivos
  /*private dateRange: DateRange = {
    start: new Date("2024-12-01"),
    end: new Date("2024-12-31"),
  };*/
  private dateRange: DateRange = {
    start: new Date(new Date().setDate(new Date().getDate() - 15)),
    end: new Date(),
  };

  private recentRecords: TimeRecord[] = [];
  private recentRecordsPromedio: DashboardPromedioHorasDiaDto[] = [];
  private absentDays: Date[] = [];

  private analytics: Analytics = {
    totalHours: 0,
    avgHoursPerDay: 0,
    workedDays: 0,
    attendanceRate: 0,
    lateArrivals: 0,
    lateRate: 0,
    overtimeHours: 0,
    overtimeRate: 0,
    productivityScore: 0,
  };
  async refresh_fichajes_empleado() {
    this.recentRecords = []; // Opcional: limpiar antes de cargar
    await fichajes_empleadoModule
      .PostDash_empleadosByIdUsuario({
        id: Number.parseInt(this.$route.params.id),
        fecha_desde: this.dateRange.start,
        fecha_hasta: this.dateRange.end,
      })
      .then((data: any[]) => {
        data.forEach((record) => {
          // Asegurarse de convertir strings a Date
          const fechaEntrada = new Date(record.primera_entrada);
          const fechaSalida = new Date(record.ultima_salida);

          if (fechaSalida > fechaEntrada) {
            const minutosTrabajados = Math.floor(
              (fechaSalida.getTime() - fechaEntrada.getTime()) / (1000 * 60)
            );

            const horas = Math.floor(minutosTrabajados / 60);
            const minutos = minutosTrabajados % 60;

            const totalHoras = parseFloat(
              `${horas}.${minutos.toString().padStart(2, "0")}`
            );

            const timeRecord: TimeRecord = {
              id: record.id,
              date: fechaEntrada,
              clockIn: fechaEntrada.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              }),
              clockOut: fechaSalida.toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              }),
              date_in: fechaEntrada,
              date_out: fechaSalida,
              totalHours: record.duracion,
              status: record.status,
              Hours: totalHoras,
            };

            this.recentRecords.push(timeRecord);
            // Aquí haces lo que necesites con `totalHoras`
          } else {
            // No haces nada o marcas el registro como inválido
            console.warn(
              `Registro inválido: la fecha de salida (${fechaSalida}) es anterior a la fecha de entrada (${fechaEntrada})`
            );
          }
        });
        this.updateAnalytics();
      });
    await fichajes_empleadoModule
      .PostDashTiempoMedio({
        id: Number.parseInt(this.$route.params.id),
        fecha_desde: this.dateRange.start,
        fecha_hasta: this.dateRange.end,
      })
      .then((data: any) => {
        this.recentRecordsPromedio = data.map((item: any) => ({
          dia_numero_semana: item.dia_numero_semana,
          dia_semana: item.dia_semana,
          horas_media: item.horas_media,
        }));
      });
  }
  public get paramId(): string {
    return this.$route.params.id as string;
  }
  /*
  private insights: Insight[] = [
    {
      id: 1,
      title: "🌅 Patrón de Madrugador",
      description:
        "Tiendes a ser más productivo en las primeras horas del día. Considera negociar un horario más temprano para aprovechar tu pico de energía.",
    },
    {
      id: 2,
      title: "📈 Tendencia Positiva",
      description:
        "Tu puntualidad ha mejorado un 23% en el último mes. Mantén este ritmo y podrías alcanzar un 95% de puntualidad perfecta.",
    },
    {
      id: 3,
      title: "⚖️ Balance Trabajo-Vida",
      description:
        "Trabajas una media de 8.4h/día, ligeramente por encima del promedio. Considera optimizar tu tiempo para mantener un mejor equilibrio.",
    },
    {
      id: 4,
      title: "🚀 Oportunidad de Mejora",
      description:
        "Los martes y miércoles son tus días más productivos. Planifica tareas importantes en estos días para maximizar tu rendimiento.",
    },
  ];*/

  get insights(): Insight[] {
    return [
      {
        id: 1,
        title: "🌄 Máxima eficiencia al inicio de la semana",
        description: ` Tus días más productivos son ${this.topProductiveDays
          .map((d) => d.charAt(0).toUpperCase() + d.slice(1))
          .join(
            " y "
          )}. Considera asignar tareas estratégicas o de mayor carga cognitiva en esos días.`,
      },
      {
        id: 2,
        title: "🕓 Patrón de puntualidad con tendencia irregular",
        description: `Has acumulado ${this.analytics.lateArrivals} llegadas tarde, principalmente entre mitad y final de semana. Considera reforzar rutinas de inicio del día.`,
      },
      {
        id: 3,
        title: "💡 Horarios extendidos con riesgo de sobrecarga",
        description: `Acumulas ${
          this.analytics.overtimeHours
        }h extra (${this.analytics.overtimeRate.toFixed(
          1
        )}%). Considera revisar tu balance trabajo-descanso.`,
      },
      /*{
        id: 4,
        title: "📅 Días sin fichaje detectados",
        description: `Se han encontrado ${this.absentDays.length} días sin actividad registrada. Asegúrate de que estén justificadas.`,
      },*/
      {
        id: 5,
        title: "🤝 Día Óptimo para Reuniones",
        description: `  Según tus patrones de productividad y puntualidad, el mejor día para reuniones es  ${this.optimalMeetingDay}`,
      },
      {
        id: 6,
        title: "🔥 Riesgo de sobrecarga",
        description: `El sistema ha detectado un ${this.burnoutRiskLevel} riesgo de burnout en base a tus horas extra y carga diaria.`,
      },
    ];
  }

  // Computed properties para los datos de los gráficos
  get hoursChartData(): ChartDataPoint[] {
    const diasSemana: Record<number, { day: string; hours: number }> = {
      1: { day: "Dom", hours: 0 },
      2: { day: "Lun", hours: 0 },
      3: { day: "Mar", hours: 0 },
      4: { day: "Mié", hours: 0 },
      5: { day: "Jue", hours: 0 },
      6: { day: "Vie", hours: 0 },
      7: { day: "Sáb", hours: 0 },
    };

    this.recentRecordsPromedio.forEach((record) => {
      const dia = record.dia_numero_semana;
      if (diasSemana[dia]) {
        diasSemana[dia].hours += record.horas_media;
      }
    });

    return [2, 3, 4, 5, 6, 7, 1].map((dia) => diasSemana[dia]);
  }

  get arrivalChartData(): ChartDataPoint[] {
    return [
      {
        status: "Temprano",
        count: this.recentRecords.filter((r) => r.status === "early").length,
      },
      {
        status: "Tarde",
        count: this.recentRecords.filter((r) => r.status === "late").length,
      },
      {
        status: "Puntual",
        count: this.recentRecords.filter((r) => r.status === "normal").length,
      },
    ];
  }

  get weeklyChartData(): ChartDataPoint[] {
    const semanas: Record<
      string,
      { totalDias: number; diasProductivos: number }
    > = {};

    this.recentRecords.forEach((record) => {
      const fecha = new Date(record.date);
      const primerDiaDelAno = new Date(fecha.getFullYear(), 0, 1);
      const diffDias = Math.floor(
        (fecha.getTime() - primerDiaDelAno.getTime()) / (1000 * 60 * 60 * 24)
      );
      const numeroSemana = Math.ceil(
        (diffDias + primerDiaDelAno.getDay() + 1) / 7
      );
      const claveSemana = `Semana ${numeroSemana}`;

      if (!semanas[claveSemana]) {
        semanas[claveSemana] = { totalDias: 0, diasProductivos: 0 };
      }

      semanas[claveSemana].totalDias += 1;
      if (record.status !== "late") {
        semanas[claveSemana].diasProductivos += 1;
      }
    });

    const resultado: ChartDataPoint[] = [];

    Object.entries(semanas).forEach(([semana, datos]) => {
      const porcentaje =
        datos.totalDias > 0
          ? Math.round((datos.diasProductivos / datos.totalDias) * 100)
          : 0;

      resultado.push({ week: semana, productivity: porcentaje });
    });

    // Ordenar por número de semana
    resultado.sort((a, b) => {
      const nA = parseInt(a.week!.replace("Semana ", ""));
      const nB = parseInt(b.week!.replace("Semana ", ""));
      return nA - nB;
    });
    console.log("Weekly Chart Data:", resultado);
    return resultado;
  }

  // Métodos
  mounted(): void {
    this.refresh_fichajes_empleado();
  }

  private formatDate(date: Date): string {
    return date.toLocaleDateString("es-ES", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }

  private getStatusText(status: string): string {
    const statusMap: Record<string, string> = {
      normal: "Normal",
      late: "Tarde",
      early: "Temprano",
      overtime: "Extra",
    };
    return statusMap[status] || status;
  }

  /*
  
  Tus días más productivos son ${this.topProductiveDays
    .map((d) => d.charAt(0).toUpperCase() + d.slice(1))
    .join(" y ")}. Considera asignar tareas estratégicas o de mayor carga cognitiva en esos días.

  */

  private updateAnalytics(): void {
    const records = this.recentRecords;

    if (records.length === 0) {
      this.analytics = {
        totalHours: 0,
        avgHoursPerDay: 0,
        workedDays: 0,
        attendanceRate: 0,
        lateArrivals: 0,
        lateRate: 0,
        overtimeHours: 0,
        overtimeRate: 0,
        productivityScore: 0,
      };
      return;
    }

    const diasUnicos = new Set(records.map((r) => r.date.toDateString()));
    const workedDays = diasUnicos.size;

    const totalHours = records.reduce((sum, r) => sum + r.Hours, 0);
    const lateArrivals = records.filter((r) => r.status === "late").length;
    const overtimeHours = records
      .filter((r) => r.status === "overtime")
      .reduce((sum, r) => sum + r.Hours, 0);

    const totalDaysInRange =
      Math.ceil(
        (this.dateRange.end.getTime() - this.dateRange.start.getTime()) /
          (1000 * 60 * 60 * 24)
      ) + 1;

    this.analytics.totalHours = Math.round(totalHours * 100) / 100;
    this.analytics.workedDays = workedDays;
    this.analytics.avgHoursPerDay =
      workedDays > 0 ? Math.round((totalHours / workedDays) * 100) / 100 : 0;

    // Limitar a 100% como máximo
    this.analytics.attendanceRate =
      totalDaysInRange > 0
        ? Math.min(100, Math.round((workedDays / totalDaysInRange) * 100))
        : 0;

    this.analytics.lateArrivals = lateArrivals;
    // También limitar a 100% como máximo
    this.analytics.lateRate =
      workedDays > 0
        ? Math.min(100, Math.round((lateArrivals / workedDays) * 100))
        : 0;

    this.analytics.overtimeHours = Math.round(overtimeHours * 100) / 100;
    this.analytics.overtimeRate =
      totalHours > 0 ? Math.round((overtimeHours / totalHours) * 1000) / 10 : 0;

    // Productividad: fórmula artificial que también se limita a 100%
    const rawScore =
      100 -
      Math.min(
        100,
        this.analytics.lateRate * 1.5 +
          (100 - this.analytics.attendanceRate) * 0.5
      );
    this.analytics.productivityScore = Math.max(
      0,
      Math.min(100, Math.round(rawScore * 10) / 10)
    );
    this.generar_ausencias();
  }

  generar_ausencias() {
    const records = this.recentRecords;
    // Generar lista de días sin asistencia
    const allDatesInRange: Date[] = [];
    let current = new Date(this.dateRange.start);

    while (current <= this.dateRange.end) {
      allDatesInRange.push(new Date(current));
      current.setDate(current.getDate() + 1);
    }

    const diasConFichaje = new Set(records.map((r) => r.date.toDateString()));

    this.absentDays = allDatesInRange.filter(
      (d) => !diasConFichaje.has(d.toDateString())
    );
  }

  get optimalMeetingDay(): string {
    const dias: Record<
      number,
      {
        totalHours: number;
        count: number;
        lateCount: number;
        overtimeCount: number;
      }
    > = {
      0: { totalHours: 0, count: 0, lateCount: 0, overtimeCount: 0 },
      1: { totalHours: 0, count: 0, lateCount: 0, overtimeCount: 0 },
      2: { totalHours: 0, count: 0, lateCount: 0, overtimeCount: 0 },
      3: { totalHours: 0, count: 0, lateCount: 0, overtimeCount: 0 },
      4: { totalHours: 0, count: 0, lateCount: 0, overtimeCount: 0 },
      5: { totalHours: 0, count: 0, lateCount: 0, overtimeCount: 0 },
      6: { totalHours: 0, count: 0, lateCount: 0, overtimeCount: 0 },
    };

    this.recentRecords.forEach((r) => {
      const dia = r.date.getDay();
      dias[dia].totalHours += r.totalHours;
      dias[dia].count += 1;
      if (r.status === "late") dias[dia].lateCount += 1;
      if (r.status === "overtime") dias[dia].overtimeCount += 1;
    });

    const diasSemana: Record<number, string> = {
      0: "Domingo",
      1: "Lunes",
      2: "Martes",
      3: "Miércoles",
      4: "Jueves",
      5: "Viernes",
      6: "Sábado",
    };

    const ranking = Object.entries(dias)
      .map(([dia, datos]) => {
        const d = Number(dia);
        if (datos.count === 0) return { dia: d, score: -1 };
        const avgHours = datos.totalHours / datos.count;
        const puntualidad = 1 - datos.lateCount / datos.count;
        const cargaEstable = Math.abs(avgHours - 8) <= 1 ? 1 : 0.5;
        const penalizacionHorasExtra = datos.overtimeCount > 0 ? 0.7 : 1;
        const score = puntualidad * cargaEstable * penalizacionHorasExtra;
        return { dia: d, score };
      })
      .filter((d) => d.score > 0)
      .sort((a, b) => b.score - a.score);

    return ranking.length > 0
      ? diasSemana[ranking[0].dia]
      : "No hemos encontrado un día óptimo";
  }

  get burnoutRiskLevel(): string {
    const total = this.recentRecords.length;
    if (total === 0) return "Bajo";

    const diasConHorasLargas = this.recentRecords.filter(
      (r) => r.totalHours >= 9
    ).length;
    const ratioLargos = diasConHorasLargas / total;

    const overtime = this.analytics.overtimeRate;

    if (ratioLargos > 0.5 || overtime > 20) return "Alto";
    if (ratioLargos > 0.3 || overtime > 10) return "Moderado";
    return "Bajo";
  }

  get topProductiveDays(): string[] {
    const diasSemana: Record<number, string> = {
      0: "domingo",
      1: "lunes",
      2: "martes",
      3: "miércoles",
      4: "jueves",
      5: "viernes",
      6: "sábado",
    };

    const agregados: Record<
      number,
      { totalHoras: number; total: number; onTime: number }
    > = {
      0: { totalHoras: 0, total: 0, onTime: 0 },
      1: { totalHoras: 0, total: 0, onTime: 0 },
      2: { totalHoras: 0, total: 0, onTime: 0 },
      3: { totalHoras: 0, total: 0, onTime: 0 },
      4: { totalHoras: 0, total: 0, onTime: 0 },
      5: { totalHoras: 0, total: 0, onTime: 0 },
      6: { totalHoras: 0, total: 0, onTime: 0 },
    };

    this.recentRecords.forEach((r) => {
      const dia = r.date.getDay();
      agregados[dia].totalHoras += r.totalHours;
      agregados[dia].total += 1;
      if (r.status !== "late") agregados[dia].onTime += 1;
    });

    const ranking = Object.entries(agregados)
      .filter(([_, datos]) => datos.total > 0)
      .map(([diaStr, datos]) => {
        const dia = Number(diaStr);
        const avgHoras = datos.totalHoras / datos.total;
        const puntualidad = datos.onTime / datos.total;
        const score = avgHoras * puntualidad;
        return { dia, score };
      })
      .sort((a, b) => b.score - a.score)
      .slice(0, 2); // top 2

    return ranking.map((x) => diasSemana[x.dia]);
  }
}
